import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../common/Question';
import YesNoDescriptionInputGroup from '../../common/YesNoDescriptionInputGroup';
import './ResponsibilitiesTab.scss';

const responsibilityExampleText = `This has been a part of my responsibilities over my career.
Most recently, I was responsible for managing a 50 site study.
My responsibilities included creation of a project plan, obtaining the CMO and CEO’s
approval of the timelines and budget, and executing to that plan.
I typically use Microsoft Project to generate the project plan but am happy to use whatever
the company prefers.`;

const negativeResponsibilityExampleText = `No, I have not specifically been a project manager
on late phase (phase III/IV) trials. Most of my work has been in phase I-II
trials as well as translational research.`;

function ResponsibilitiesTab({
  project, proposal, onFormChange, errors,
}) {
  const { responsibility_areas } = project;
  let displayedExampleText = responsibilityExampleText;

  if (proposal.responsibility_areas) {
    displayedExampleText = proposal.responsibility_areas.some((p) => p.selected === 'No') ? negativeResponsibilityExampleText : responsibilityExampleText;
  }

  return (
    <div className="responsibilities-tab">
      { responsibility_areas.length === 0
      && (
      <div className="no-requirements-placeholder">
        The Employer has not specified any requirements.
      </div>
      )}

      { responsibility_areas.length > 0
        && (
        <div className="mb-3 responsibilities">
          <Question
            title="Can you fulfill the following responsibilities?"
            location="proposal-edit"
          >
            <div className="mt-25 ms-3">
              <YesNoDescriptionInputGroup
                options={responsibility_areas}
                formKey="responsibility_areas"
                onAnswerChange={(val) => onFormChange('responsibility_areas', val)}
                errors={errors}
                value={proposal.responsibility_areas}
                requiredDescriptionValues={['No', 'Yes']}
                exampleText={displayedExampleText}
                textAreaPrompt="Provide details about your experience related to
                this responsibility. It is important to be thorough to ensure
                potential employers can efficiently evaluate fit. Note: minimum of 50 characters"
              />
            </div>
          </Question>
        </div>
        )}
    </div>
  );
}

ResponsibilitiesTab.propTypes = {
  project: PropTypes.shape({}).isRequired,
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
};

export default ResponsibilitiesTab;
